import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'vui-input-facet',
    templateUrl: './input-facet.component.html',
    styleUrls: ['./input-facet.component.scss']
})
export class InputFacetComponent {
    @Input() public errors: any;
    @HostBinding('class.focussed') @Input() public focussed: boolean;
    @Input() public id: string;
    @Input() public title: string;
    @Input() public value: any;
}
